<template>
    <div>
        <!-- Modal -->
        <b-modal id="editModal" title="editar usuario" class="" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <EditUserForm :userProp="user"></EditUserForm>
            
        </b-modal>
    </div>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import EditUserForm from '@/components/UserMaintainer/UserEdit/Edit-user-form.vue'

export default {
    name: 'UserEdit',

    data() {
        return {
            modalShow: false,
            user: null
        }
    },

    components:{
        EditUserForm
    },

    mounted() {
        this.$eventBus.$on(EventNames.OpenModalEditUser, (query) => {
            this.user = query[0];
            this.openModal();
        });

        this.$eventBus.$on(EventNames.ModifyUser, () => {
            this.closeModal();
        });
    },

    methods: {
        openModal() {
            this.modalShow = true;
        },
        closeModal() {
            this.modalShow = false;
        }
    }

}
</script>
<style></style>